import { useNavigate } from "react-router-dom";

import { DRAFT_STATUS_PATH } from "@PressListContainer/draftStatusInfo.constants";
import { ROUTE_PATHS } from "@routes/routePath";

import type { ClassificationCode, ProcessStatusCode } from "@/types/code.types";

interface Args {
  draftArticleId: string;
  draftArticleStatus: ProcessStatusCode;
  classificationAi: ClassificationCode;
}

export const useMovePressDetailPage = ({
  draftArticleId,
  draftArticleStatus,
  classificationAi,
}: Args) => {
  const navigate = useNavigate();

  const movePressDetailPage = () => {
    let pathname = DRAFT_STATUS_PATH[draftArticleStatus];

    if (classificationAi === "C801" || classificationAi === "C802") {
      pathname = ROUTE_PATHS.fillInTable;
    }

    const url = `${pathname}?id=${draftArticleId}`;

    if (
      pathname !== ROUTE_PATHS.pressClassification &&
      pathname !== ROUTE_PATHS.fillInTable &&
      pathname !== ROUTE_PATHS.insertImage &&
      pathname !== ROUTE_PATHS.editArticle
    ) {
      throw new Error(`${pathname}는 잘못된 경로입니다.`);
    }

    navigate(url);
  };

  return {
    movePressDetailPage,
  };
};
